import { useContext, useCallback } from 'react';
import { useSelector } from '@xstate/react';

import { GlobalStateContext } from '../../../contexts';

import { productCatalogSelectors } from '../../../machines';

export const useProductCatalog = () => {
  const { productCatalogService } = useContext(GlobalStateContext);

  const items = useSelector(
    productCatalogService,
    productCatalogSelectors.getProductCatalogItems
  );

  const { isLoading, error, ready } = useSelector(
    productCatalogService,
    productCatalogSelectors.getProductCatalogFetchStatus
  );

  const initialize = useCallback(() => {
    if (error) productCatalogService.send('RETRY_FETCH_PRODUCT_CATALOG');
    else productCatalogService.send('INITIALIZE');
  }, [error]);

  return {
    items,
    error,
    ready,
    isLoading,
    initialize,
  };
};
